<template>
  <v-card>
    <v-toolbar class="grey lighten-4 elevation-0">
      <v-toolbar-title class="grey--text text-underline text--darken-4">
        Companies
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-flex xs2 class="mr-4">
        <v-card flat>
          <v-select :items="status_filter" v-model="currentStatus" label="Status" single-line bottom></v-select>
        </v-card>
      </v-flex>
      <v-flex xs3 style="margin-left: auto">
        <v-card flat>
          <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card>
      </v-flex>
    </v-card-title>
    <v-data-table :headers="headers" :loading="loadingTable" :items="allCompanies" :search="search" :rows-per-page-items="[15, 25, 50, 100]">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.submitdate | actualDate }}</td>
        <td class="text-xs-left">
          {{ props.item.firstname }} {{ props.item.lastname }}
        </td>
        <td class="text-xs-left">
          <v-avatar
            size="24"
            color="secondary">
            <span
              v-if="!props.item.companylogo && props.item.companylegalname"
              class="white--text">
              {{ props.item.companylegalname.charAt(0) }}
            </span>
            <img
              v-else
              :src="props.item.companylogo" alt="logo"
              size="24"/>
          </v-avatar>
          <!-- <div class="avatar" style="height: 24px; width: 24px;">
            <img :src="props.item.companylogo" alt="logo">
          </div> -->
          {{ props.item.companylegalname }}
        </td>

        <td class="text-xs-left">{{ props.item.companydescription | sliceText }}</td>
        <td class="text-xs-left">{{ props.item.verified === true ? 'Verified' : (props.item.rejected ?
          'Rejected':'Pending Action') }}</td>
        <td class="text-xs-left">
          <v-layout row>
            <v-flex xs3 sm3 v-if="props.item.verified === false">
              <v-btn style="margin-left: 0px" @click.prevent="approveSubmission(props.item.id, props.item.uid)" icon
                class="green--text">
                <v-icon>done</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs3 sm3 v-else>
              <v-btn slot="activator" style="margin-left: 0px" @click.prevent="rejectSubmission(props.item.id, props.item.uid)"
                icon class="red--text">
                <v-icon>clear</v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn @click.prevent="selectItem(props.item);assignId(props.item.id, 'activeDialog')" icon style="margin-left: 0px"
                class="blue--text">
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn style="margin-left: 0px" slot="activator" icon medium @click="selectItem(props.item);assignId(props.item.id, 'emailDialog')"
                :disabled="props.item.verified !== true && props.item.rejected !== true">
                <v-icon medium>email</v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn slot="activator" icon style="margin-left: 0px" @click.prevent="selectItem(props.item);assignId(props.item.id, 'dialog')"
                class="red--text">
                <v-icon>delete_forever</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <v-dialog v-model="activeDialog" fullscreen transition="dialog-bottom-transition" :overlay="false" scrollable lazy
      absolute width="790px">
      <v-card>
        <v-layout row>
          <v-flex xs12 sm12>
            <v-toolbar flat style="flex: 0 0 auto;" dark class="primary">
              <v-btn icon @click.native="activeDialog = false" dark>
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Settings</v-toolbar-title>
            </v-toolbar>
            <companyInfo v-if="selectedItem.uid" :props="selectedItem" />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailDialog" lazy absolute max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">Confim Email</div>
        </v-card-title>
        <v-card-text>Are you sure you want to mail user <b>{{ selectedItem.firstname + " " + selectedItem.lastname }}</b>?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="emailDialog = false">No</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="emailDialog= false;emailUser(selectedItem.uid, selectedItem.verified, selectedItem.rejected)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" lazy absolute max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">Really delete?</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete <b>{{ selectedItem.firstname + " " + selectedItem.lastname }}'s</b> Submission?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="dialog = false">No</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="deleteRow()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import axios from 'axios'
import companyInfo from './company/company_info.vue'
import contractInfo from './company/contract_info.vue'
import otherInfo from './company/other_info.vue'

export default {
  components: {
    companyInfo,
    contractInfo,
    otherInfo
  },
  mounted () {
    this.fetchCompanySubmissions()
  },
  computed: {
    companies () {
      return this.$store.getters.getCompanySubmissions || []
    },
    process () {
      return this.$store.getters.getProcess
    },
    allCompanies () {
      if (this.currentStatus === true || this.currentStatus === false) {
        return this.companies.filter((company) => company.verified === this.currentStatus).sort((d1, d2) => new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime())
      } else {
        return this.companies.filter((company) => company.dunsnumber != null).sort((d1, d2) => new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime())
      }
    }
  },
  data () {
    return {
      loadingTable: false,
      selectedItem: {
        user: {}
      },
      search: '',
      e1: '',
      emailDialog: false,
      ex11: true,
      pagination: {},
      cmp1: [],
      activeDialog: false,
      dialog: false,
      currentStatus: 'all',
      currentEventId: '',
      dateRange: 0,
      view_dialog: false,
      info: [
        {
          name: 'Company Info',
          tabId: 'company_info'
        },
        {
          name: 'Contracting Info',
          tabId: 'contracting_info'
        },
        {
          name: 'Other Info',
          tabId: 'other_info'
        }
      ],
      headers: [
        {
          text: 'Submit date',
          align: 'left',
          sortable: false,
          value: 'companyname'
        },
        {
          text: 'Submitter',
          value: 'user',
          align: 'left',
          sortable: false
        },
        {
          text: 'Company name',
          value: 'title',
          align: 'left',
          sortable: false
        },
        {
          text: 'Company Description',
          align: 'left',
          sortable: false,
          value: 'posteddate'
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'Actions',
          align: 'left',
          sortable: false
        }
      ],
      status_filter: [
        {
          text: 'All',
          value: 'all'
        },
        {
          text: 'Verified',
          value: true
        },
        {
          text: 'Not Verified',
          value: false
        }
      ],
      default_filter: [
        {
          text: 'Last 24hrs'
        },
        {
          text: 'Last 7 days'
        },
        {
          text: 'Last 30 days'
        }
      ],
      items: []
    }
  },
  methods: {
    async fetchCompanySubmissions () {
      try {
        this.loadingTable = true
        await this.$store.dispatch('fetchCompanySubmissions')
        this.loadingTable = false
      } catch (err) {
        let snackbar = {
          active: true,
          text: 'An error occurred while fetching the company submissions'
        }
        this.$store.commit('triggerSnackbar', snackbar)
        this.loadingTable = false
      }
    },
    selectItem (item) {
      this.selectedItem = item
    },
    changeStatus (status, postId) {
      let api = 'https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2'
      const company = this.companies.filter((company) => company.id === postId)
      const postData = company[0]
      const payload = {
        type: 'companies',
        status,
        postId
      }
      if (status) {
        return axios.delete(`${api}/${postId}`)
        .then((response) => {
          return axios.post(api, postData)
        .then((response) => {
          payload.id = response.data['_id']
          this.$store.dispatch('verifyCompany', payload)
        })
        .catch((error) => {
          return error
        })
        })
        .catch((error) => {
          return error
        })
      }

      return this.$store.dispatch('verifyCompany', payload)
    },
    emailUser (uid, verified, rejected) {
      if (rejected === true) {
        this.$store.dispatch('sendMail', {uid: uid, action: 'company_rejected'})
      } else if (verified === true) {
        this.$store.dispatch('sendMail', {uid: uid, action: 'company_approved'})
      }
    },
    approveSubmission (cid, uid) {
      this.$store.dispatch('approveCompanySubmission', {cid: cid, uid: uid})
    },
    rejectSubmission (cid, uid) {
      this.$store.dispatch('rejectCompanySubmission', {cid: cid, uid: uid})
    },
    filterStatus (status) {
      this.currentStatus = status
    },
    async deleteRow () {
      await this.$store.dispatch('deleteCompanySubmision', {
        cid: this.selectedItem.id,
        uid: this.selectedItem.uid
      })
      this.dialog = false
    },
    assignId (postId, type) {
      this.currentCompanyId = postId
      this[type] = true
    }
  }
}
</script>

<style scoped>
  #right {
    float: right !important;
  }
  #toggle_status {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// company.vue?570f4307